import type { FC, PropsWithChildren } from 'react';
import React, { useCallback, useState } from 'react';

import Flex from '../Flex';
import Scrollable from '../Scrollable';
import { VisibilityObserverRootContextProvider } from '../VisibilityObserver';

import { getClassNames } from './AppLayoutRow.styles.legacy';
import type { AppLayoutRowProps } from './AppLayoutRow.types';
import { useScrollToTopOnRouteChange } from './hooks';

const AppLayoutRow: FC<PropsWithChildren<AppLayoutRowProps>> = ({
  children,
  layoutRegion,
  height,
  grow,
  paddingTop,
  paddingBottom,
  role,
  enableScrolling = false,
  forceScrollable = false,
  shrink,
  zIndex,
  depth,
}) => {
  const [scrollableElement, setScrollableElement] = useState<HTMLElement | null>(null);
  const scrollableRef = useCallback((node: HTMLElement | null) => {
    setScrollableElement(node);
  }, []);
  useScrollToTopOnRouteChange(scrollableElement);

  const minHeight = grow ? 0 : undefined;

  const shouldWrapInScrollable = enableScrolling || forceScrollable;

  const content = shouldWrapInScrollable ? (
    <Scrollable width="100%" ref={scrollableRef} disableScrolling={!enableScrolling}>
      <VisibilityObserverRootContextProvider root={scrollableElement}>{children}</VisibilityObserverRootContextProvider>
    </Scrollable>
  ) : (
    children
  );

  const classNames = getClassNames(zIndex, depth);

  return (
    <Flex
      height={height}
      grow={grow}
      minHeight={minHeight}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      role={role}
      shrink={shrink}
      className={classNames.appLayoutRow}
      data-app-layout-region={layoutRegion}
    >
      {content}
    </Flex>
  );
};

export default AppLayoutRow;
